import styled from "styled-components";
import { Link } from "react-router-dom";
import { primaryColor, primaryColorHover } from "../../../../../config/constants";

// Styles
export const MainDiv = styled.div`
  margin: 0 auto 5px;
  max-width: 860px;
  @media (max-width: 910px) {
    margin: 0 auto 10px;
    width: 85%;
  }
`;
export const Div = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const Text = styled.p`
  width: ${({ width }) => width && width};
  font-size: 14px;
  text-align: center;
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
    font-size: 12px;
  }
`;
export const VideoButton = styled.button`
  width: 350px;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: none;
  border-radius: 5px;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const ProtocolImgDiv = styled.div`
  margin-right: 15px;
  width: 80px;
  height: 40px;
  position: relative;
`;
export const ProtocolImg = styled.img`
  width: 80px;
  height: 100%;
`;
export const InfoVideoImg = styled.img`
  width: 23px;
  height: 23px;
`;
export const ProtocolName = styled.p`
  margin-left: 15px;
  font-size: 14px;
  color: #000;
  font-weight: 600;
  text-align: left;
`;

export const DetailsDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const DetailsLink = styled(Link)`
  margin-right: 20px;
  width: 35px;
  height: 35px;
  background-color: ${({ sessions }) => (sessions > 0 ? primaryColor : "#808080")};
  border-radius: 5px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
  @media (max-width: 910px) {
    width: 25px;
    height: 25px;
  }
`;
export const DetailsImg = styled.img`
  width: 70%;
  height: 70%;
`;
